import React, { Component } from "react";
import { Box } from "reflexbox";
import OrdersTable from "./Table/_OrdersTable";

class Orders extends Component {
  render() {
    return (
      <Box>
        <OrdersTable />
      </Box>
    );
  }
}

export default Orders;



// WEBPACK FOOTER //
// ./src/views/Orders/index.js